import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/authentication.service';
import {Router} from '@angular/router';
import {CustomStyleService} from '../../services/custom-style.service';
import { environment } from 'environments/environment';
import {CookieService} from '../../services/cookie.service';
import {ApiClientService} from '../../services/api-client.service';

declare const toastr: any;

@Component({
    selector: 'login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
    email = '';
    password = '';
    showPassword = false;

    isError = false;
    public forgotPassLink = `${environment.oauthUrl}/resetPassword`;
    public requestAccessLink = `${environment.oauthUrl}/reInvite`;

    constructor(private authService: AuthenticationService,
                public api: ApiClientService,
                private router: Router,
                public cs: CustomStyleService,
                public cookieService: CookieService,
    ) {}

    submit() {
        this.authService.login(this.email, this.password)
            .subscribe(
                (userData) => {
                        userData.subscribe(res => {
                            const reference_redirect = this.cookieService.get('redirect_after_login');
                            if (reference_redirect) {
                                this.cookieService.delete('redirect_after_login', '/', '.' + environment.domainName);
                                window.location.href = reference_redirect;
                            } else {
                                this.router.navigateByUrl('/home');
                            }
                        }, error => this.isError = true);
                },
                error => {
                    this.api.errorHandler(error, 'Your username or password is incorrect. Click "Reset Password" to get a reset link');
                    this.isError = true;
                }
            );
    }

    resetError() {
        this.isError = false;
    }

    ngOnInit() {
        if (this.authService.isAuthorized()) {
            this.router.navigateByUrl('/home');
        }
        this.prepareStyleForgotPassword();
    }

    prepareStyleForgotPassword(): void {
        const csEncoded = localStorage.getItem('mtvCustomStyle');
        this.forgotPassLink = csEncoded ? `${this.forgotPassLink}?customStyle=${btoa(csEncoded)}` : this.forgotPassLink;
        this.requestAccessLink = csEncoded ? `${this.requestAccessLink}?customStyle=${btoa(csEncoded)}` : this.requestAccessLink;
    }

    ngAfterViewInit() {
        document.body.classList.add('gray-bg');
    }

    ngOnDestroy() {
        document.body.classList.remove('gray-bg');
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/login/login.component.ts